<script lang="ts">
import PlantApi from '@/data/plants/PlantApi.ts';
import Plant from '@/domain/model/business/Plant.ts';

export default {
  name: 'PlantCompaniesMultiSelect',
  props: {
    companyId: Number,
    plant: Plant,
  },
  emits: ['selection-changed'],
  data() {
    return {
      selectedChildCompanyIds: [],
      childCompanies: [],
      loading: false,
    };
  },
  created() {
    if (this.plant.getCompanies() && this.plant.getCompanies().length > 0) {
      this.childCompanies = this.mapChildCompanies(this.plant.getCompanies());
      this.setDefault();
    } else {
      this.getChildCompanies();
    }
  },
  methods: {
    getChildCompanies() {
      this.loading = true;

      new PlantApi()
        .setMinimumDurationMsForCalls(200)
        .getCompanies(this.companyId, this.plant.getId())
        .then((response) => {
          this.childCompanies = this.mapChildCompanies(response.data);
          this.setDefault();
        })
        .finally(() => (this.loading = false));
    },
    mapChildCompanies(companies) {
      return companies
        .filter((company) => !company.is_owner)
        .map((company) => {
          return { id: company.id, name: company.name };
        });
    },
    setDefault() {
      if (this.childCompanies && this.childCompanies.length === 1) {
        this.selectedChildCompanyIds = [this.childCompanies[0].id];
        this.$emit('selection-changed', this.selectedChildCompanies);
      }
    },
    handleSelectionChanged() {
      this.$emit('selection-changed', this.selectedChildCompanies);
    },
  },
  computed: {
    selectedChildCompanies() {
      return this.childCompanies.filter((company) =>
        this.selectedChildCompanyIds.includes(company.id),
      );
    },
  },
};
</script>

<template>
  <div v-if="loading">
    <Skeleton width="5rem" height="1.25rem" class="mb-1 mt-2" />
    <Skeleton height="2.35rem" />
  </div>

  <div v-else>
    <MultiSelect
      v-if="childCompanies.length > 0"
      v-model="selectedChildCompanyIds"
      @change="handleSelectionChanged()"
      :options="childCompanies"
      option-label="name"
      option-value="id"
      :max-selected-labels="1"
      :selected-items-label="
        $t('primevue.selectionMessage', [selectedChildCompanyIds.length])
      "
      display="comma"
      :show-toggle-all="false"
      scroll-height="25rem"
      :placeholder="$t('global.select_an_option')"
      class="w-full"
    />
  </div>
</template>

<style scoped></style>
